import React, { useEffect, useState } from "react";
import {
  Breadcrumb,
  Spin,
  Table,
  Input,
  Space,
  Button,
  Popconfirm,
} from "antd";
import {
  SearchOutlined,
  DeleteOutlined,
  EditOutlined,
} from "@ant-design/icons";
import Title from "antd/lib/typography/Title";
import Highlighter from "react-highlight-words";
import { Link } from "react-router-dom";
import { openNotificationWithIcon, FetchURL, addFormData } from "../../../util/help";
import { actHideLoading, actShowLoading } from "../../../actions/actionLoading";
import { useDispatch, useSelector } from "react-redux";
import axios from "../../../util/api";
import { deleteCarrier, fetchCarrier } from "../../../actions/actionCarriers";

function Garages() {
  const [state, setState] = useState({ searchText: "", searchedColumn: "" });

  const carriers = useSelector((state) => state.carriers);
  const isLoading = useSelector((state) => state.isLoading);

  const dispatch = useDispatch();
  const getCarrier = (data) => dispatch(fetchCarrier(data));
  const showLoading = () => dispatch(actShowLoading());
  const hideLoading = () => dispatch(actHideLoading());
  const DeleteCarrier = (CUST_NO) =>
    dispatch(deleteCarrier(CUST_NO));

  useEffect(() => {
    showLoading();
    fetch(FetchURL + "data-basic/customer/type=4")
      .then((res) => res.json())
      .then((data) => {
        if (data.success === true) {
          getCarrier(data.data);
          hideLoading();
        }
      })
      .catch((err) => console.log(err));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const getColumnSearchProps = (dataIndex) => ({
    filterDropdown: ({
      setSelectedKeys,
      selectedKeys,
      confirm,
      clearFilters,
    }) => (
      <div style={{ padding: 8 }}>
        <Input
          placeholder={`Search ${dataIndex}`}
          value={selectedKeys[0]}
          onChange={(e) =>
            setSelectedKeys(e.target.value ? [e.target.value] : [])
          }
          onPressEnter={() => handleSearch(selectedKeys, confirm, dataIndex)}
          style={{ width: 188, marginBottom: 8, display: "block" }}
        />
        <Space>
          <Button
            type="primary"
            onClick={() => handleSearch(selectedKeys, confirm, dataIndex)}
            icon={<SearchOutlined />}
            size="small"
            style={{ width: 90 }}
          >
            Search
          </Button>
          <Button
            onClick={() => handleReset(clearFilters)}
            size="small"
            style={{ width: 90 }}
          >
            Reset
          </Button>
        </Space>
      </div>
    ),
    filterIcon: (filtered) => (
      <SearchOutlined style={{ color: filtered ? "#1890ff" : undefined }} />
    ),
    onFilter: (value, record) =>
      record[dataIndex]
        ? record[dataIndex]
            .toString()
            .toLowerCase()
            .includes(value.toLowerCase())
        : "",
    render: (text) =>
      state.searchedColumn === dataIndex ? (
        <Highlighter
          highlightStyle={{ backgroundColor: "#ffc069", padding: 0 }}
          searchWords={[state.searchText]}
          autoEscape
          textToHighlight={text ? text.toString() : ""}
        />
      ) : (
        text
      ),
  });

  const handleSearch = (selectedKeys, confirm, dataIndex) => {
    confirm();
    setState({
      searchText: selectedKeys[0],
      searchedColumn: dataIndex,
    });
  };

  const handleReset = (clearFilters) => {
    clearFilters();
    setState({ searchText: "" });
  };

  const Delete = (CUST_NO, CUST_NAME) => {
    const params ={
      CUST_NO:  CUST_NO,
      CUST_TYPE: 4
    }
    showLoading();
    axios
      .post("data-basic/customer/remove", addFormData(params))
      .then((res) => {
        if (res.status === 200) {
          if (res.data.success === true) {
            DeleteCarrier(CUST_NO);
            hideLoading();
            openNotificationWithIcon(
              "success",
              `Bạn đã Delete thành công ${CUST_NAME}`
            );
          }
        }
      })
      .catch((err) => console.log(err));
  };

  const columns = [
    {
      title: "CUST NO",
      dataIndex: "CUST_NO",
      key: "CUST_NO",
      ...getColumnSearchProps("CUST_NO"),
    },
    {
      title: "Tên Công Ty",
      dataIndex: "CUST_NAME",
      key: "CUST_NAME",
      ...getColumnSearchProps("CUST_NAME"),
    },
    {
      title: "Address",
      dataIndex: "CUST_ADDRESS",
      key: "CUST_ADDRESS",
      ...getColumnSearchProps("CUST_ADDRESS"),
    },
    {
      render: (text, record) => (
        <>
          <Link to={`/Dasboard/nhaxe/edit/${record.CUST_NO}`}>
            <Button
              type="primary"
              style={{
                backgroundColor: "#faad14",
                borderColor: "#faad14",
                marginRight: 20,
              }}
              icon={<EditOutlined />}
            >
              <span style={{ marginLeft: 8, color: "white" }}>Edit</span>
            </Button>
          </Link>

          <Popconfirm
            title="Bạn có chắn chắn Delete?"
            onConfirm={() => Delete(record.CUST_NO, record.CUST_NAME)}
          >
            <Button type="primary" danger icon={<DeleteOutlined />}>
              Delete
            </Button>
          </Popconfirm>
        </>
      ),
    },
  ];

  return (
    <Spin size="large" spinning={isLoading}>
      <Breadcrumb style={{ margin: "16px 0" }}>
        <Breadcrumb.Item>BASICAL DATA</Breadcrumb.Item>
        <Breadcrumb.Item>Nhà Xe</Breadcrumb.Item>
      </Breadcrumb>
      <div
        className="site-layout-background"
        style={{ padding: 24, minHeight: 360 }}
      >
        <div style={{ textAlign: "center" }}>
          <Title style={{ color: "#1890ff" }}>Nhà Xe</Title>
        </div>

        <Button type="primary" style={{ marginBottom: 20 }}>
          <Link to="/Dasboard/nhaxe/create">Create</Link>
        </Button>

        <Table
          dataSource={carriers}
          columns={columns}
          rowKey={columns[0].key.toString()}
          pagination={{ position: ["bottomLeft"] }}
        />
      </div>
    </Spin>
  );
}

export default Garages;
